import type { IWordCloud3dSeriesTheme } from './interface';

export const wordCloud3d: IWordCloud3dSeriesTheme = {
  word: {
    padding: 1,
    style: {
      textAlign: 'center',
      textBaseline: 'alphabetic'
    }
  }
};
